module.exports = __webpack_public_path__ + "static/img/application12-4.1546f3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application12-4.jpg
// module id = s64D
// module chunks = 0